<template>
  <div id="Auction" class="bgc-gradient" style="padding-bottom: 1.2rem">
    <Header :is-nav="true" title="竞拍交易"></Header>
    <Search :filterIconFlag="filterIconFlag" @onFliter="onFliter()" @onSearch="onSearch"></Search>
    <van-tabs v-model="activeTab">
      <van-tab v-for="item in tabList" :key="item.key" :name="item.key" :title="item.name"></van-tab>
    </van-tabs>

    <div style="overflow: auto; flex: 1">
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list v-if="auctionList.length>0" v-model="loading" :finished="finished" finished-text="没有更多了"
                  @load="load">
          <AuctionList :auctionList="auctionList"/>
        </van-list>
        <van-empty v-else class="custom-empty" description="暂无数据"></van-empty>
      </van-pull-refresh>
    </div>
    <van-popup v-model="filterFlag" :overlay="true" position="right">
      <FilterList :brandList="searchFilterData" @refreshData="refreshData" @reset="reset"></FilterList>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import AuctionList from "./components/AuctionList";
import FilterList from "./components/FilterList";
import {auction} from "@/request/auction-Api.js";
import {listButton} from "./auction-utils";
import Search from "@/components/SearchBar";

export default {
  name: "Auction",
  components: {
    Header,
    AuctionList,
    FilterList,
    Search
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      filterIconFlag: true,
      filterFlag: false,
      activeTab: "toBegin", //即将开始
      tabList: [
        {
          key: "toBegin",
          name: "即将开始",
        },
        {
          key: "inProgress",
          name: "正在竞拍",
        },
        {
          key: "completed",
          name: "已结束",
        },
        {
          key: "myIntent",
          name: "我参与的",
        },
      ],
      simpleImg: require("assets/imgs/默认产品图1.png"),
      formPage: {
        currentPage: 0,
        pageSize: 10, //列表可显示管道气和LNG的挂牌商品，默认显示10条数据，每次向上拉动加载3条数据
        middleCataNameList: [],
        sellerNameList: [],
        topCateNameList: [],
      },
      searchFilterData: [], //过滤条件数据
      auctionList: [],
      searchWord: null
    };
  },
  watch: {
    activeTab: function (tab) {
      console.log(tab);
      this.getList(true);
    },
  },
  mounted() {
    this.getList();
  },
  created() {
    this.getResourceTypesList();
  },
  methods: {
    load() {
      this.getList()
    },
    onRefresh() {
      this.finished = false;
      this.getList(true);
    },
    onSearch(value) {
      this.finished = false;
      this.searchWord = value;
      this.getList(true);
    },
    onFliter() {
      this.filterFlag = !this.filterFlag;
    },
    reset() {
      this.formPage = {
        ...this.formPage,
        middleCataNameList: [],
        sellerNameList: [],
        topCateNameList: []
      }
    },
    refreshData(brandListArg) {
      console.log(brandListArg)
      for (let i = 0; i < brandListArg.length; i++) {
        let item = brandListArg[i];
        if (item.nameKey == "middleCataNameList") {
          this.formPage.middleCataNameLis = item.options.filter((info) => {
            return info.selected == true;
          });
          continue;
        }
        if (item.nameKey == "sellerNameList") {
          this.formPage.sellerNameList = item.options.filter((info) => {
            return info.selected == true;
          });
          continue;
        }
        if (item.nameKey == "topCateNameList") {
          this.formPage.topCateNameList = item.options.filter((info) => {
            return info.selected == true;
          });
          continue;
        }
      }
      this.filterFlag = !this.filterFlag;
      this.getList("refresh");
      this.$refs.wrapper.scrollTo(0, 0, 300, "bounce");
    },
    //查询筛选条件
    async getResourceTypesList() {
      // eslint-disable-next-line no-debugger
      // debugger;
      let params = {};
      let res = await auction.getResourceTypesList(params);
      if (res.returnCode === "0") {
        console.log(JSON.stringify(res.result));
        if (res.result.isArray) {
          return false
        }

        res.result.forEach(element => {
          let arr = [];
          element.options.forEach((ar) => {
            arr.push({
              key: ar,
              value: ar,
              selected: false,
            })
          })
          // eslint-disable-next-line no-debugger
          // debugger
          this.searchFilterData.push({
            id: element.nameKey,
            name: element.name,
            nameKey: element.nameKey,
            multiple: true,
            close: false,
            options: arr,
          })
        });

      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    async getList(refresh) {
      let params = this.formPage;
      params.keyWords4App = this.searchWord
      let _this = this
      refresh
          ? (this.formPage.currentPage = 1)
          : (this.formPage.currentPage = this.formPage.currentPage + 1);
      let checkFn = (result) => {
        _this.loading = false;
        if (_this.refreshing) {
          _this.refreshing = false;
        }
        if (!result.hasNextPage) {
          _this.finished = true;
        }
      };
      // console.log(JSON.stringify(params));
      let requestList = {
        toBegin: "listAuctionToBegin",
        inProgress: "listAuctionInProgress",
        completed: "listAuctionCompleted",
        myIntent: "listAuctionMyIntent",
      };
      let requestFn = requestList[this.activeTab];
      if (!requestFn) {
        console.log(` Cannot read property ${this.activeTab} of undefined`);
        return;
      }
      this.loading = true;
      let res = await auction[requestFn](params);
      if (res.returnCode === "0") {
        refresh ? this.auctionList = res.result.dataList : this.auctionList = [...this.auctionList, ...res.result.dataList];
        this.auctionList = this.auctionList.map((item) => {
          item = Object.assign({}, item, {
            buttonStatus: listButton(item),
          });
          return item;
        });
        checkFn(res.result);

      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
  },
};
</script>

<style lang='stylus' scoped>
/deep/ .van-tabs__nav {
  background-color: transparent;
}

/deep/ .van-tab {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
}

/deep/ .van-tab--active {
  font-weight: 500;
  color: #333333;
}

/deep/ .van-tab__text--ellipsis {
  height: 30px;
  overflow: visible;
}

#Auction {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
